module.exports = __webpack_public_path__ + "img/hr-green-pita-04.9b6040a4.png";